export default "__VITE_ASSET__BXOn1BwL__"